import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getViewport, generateImageUrl, generateFixedSizeUrl } from '../../../utils/webp';

import {
  Container, Content, Title, Media, ModalButton, VideoModal, Shadow, MobileArticle,
} from '../styles/video-article.style';

const defaultProps = {
  data: {
    heroImage: {
      file: {},
    },
    description: {
      childMarkdownRemark: {},
    },
  },
};

const propTypes = {
  data: PropTypes.object,
};

/**
 * Article component
 * @param {object} props Incoming Props
 * @returns {XML} React Component
 */
class VideoArticle extends React.Component {
  /**
   *
   * @param {*} props Passed from parent component
   */
  constructor(props) {
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.state = {
      showModal: false,
      viewportWidth: 2400,
      playVideo: false,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({
        viewportWidth: getViewport(),
      });
    }
  }

  /**
   * Toggles the modal
   * @param {boolean} showModal value to toggle to
   */
  toggleModal(showModal) {
    this.setState({ showModal });
  }

  /**
   * Plays the video
   */
  playVideo() {
    this.setState({
      playVideo: true,
    });
  }

  /**
   * renders component
   * @returns {JSX} JSX for component
   */
  render() {
    const {
      data,
      isMobile,
    } = this.props;
    const {
      viewportWidth,
      showModal,
      playVideo,
    } = this.state;
    const bkgd = data && data.videoStill && data.videoStill.file && data.videoStill.file.url;
    const autoplay = playVideo ? 1 : 0;
    const videoSrc = `https://www.youtube.com/embed/${data.videoId}?autoplay=${autoplay}&rel=0&modestbranding=1`;
    let articleSource = '';
    if (data.source) {
      articleSource = data.source;
    }
    if (isMobile) {
      let displayDate = moment(data.date).format('MMMM YYYY');
      if (!data.date) {
        displayDate = moment(data.updatedAt).format('Mo YYYY');
      }
      let src = '';
      if (data && data.image && data.image.file && data.image.file.details) {
        src = generateFixedSizeUrl({
          img: {
            path: data.image.file.url,
            width: data.image.file.details.image.width,
            height: data.image.file.details.image.height,
          },
          dimensions: {
            height: 100,
            width: 100,
          },
          ratio: window.devicePixelRatio,
        });
      }
      return (
        <MobileArticle onClick={() => this.toggleModal(true)}>
          {showModal ? (
            <Shadow
              className="backdrop"
              onClick={(e) => {
                e.stopPropagation();
                this.toggleModal(false);
              }}
            >
              <VideoModal onClick={e => e.stopPropagation()}>
                <button type="button" onClick={() => this.toggleModal(false)}>
                  <img src="/images/close.svg" alt="Close Modal" />
                </button>
                <iframe src={videoSrc} title={data.title} frameBorder="0" allowFullScreen="allowFullScreen" />
              </VideoModal>
            </Shadow>
          ) : ''}
          <div className="date">{`${articleSource}${data.source && displayDate ? ' | ' : ''}${displayDate}`}</div>
          <div className="title">{data.title}</div>
          <div className="image" style={{ backgroundImage: `url('${src}')` }} />
        </MobileArticle>
      );
    }
    return (
      <Container className="article-card">
        {showModal ? (
          <Shadow
            className="backdrop"
            onClick={() => this.toggleModal(false)}
          >
            <VideoModal onClick={e => e.stopPropagation()}>
              <button type="button" onClick={() => this.toggleModal(false)}>
                <img src="/images/close.svg" alt="Close Modal" />
              </button>
              <iframe src={videoSrc} title={data.title} frameBorder="0" allowFullScreen="allowFullScreen" />
            </VideoModal>
          </Shadow>
        ) : ''}
        <ModalButton
          aria-label="Play Video"
          onClick={() => this.toggleModal(true)}
        >
          <Media img={generateImageUrl(bkgd, viewportWidth)} />
          <Content>
            <Title>{data.title}</Title>
            {data.source ? (
              <div className="source">{data.source}</div>
            ) : ''}
          </Content>
        </ModalButton>
      </Container>
    );
  }
}

VideoArticle.defaultProps = defaultProps;
VideoArticle.propTypes = propTypes;

export default VideoArticle;



// WEBPACK FOOTER //
// ./src/components/article-list/components/video-article.js